import { useLocalStorageState } from 'ahooks';
import { cloneDeep } from 'lodash-es';

type ColorType = 'pure' | 'gradient';
type LocalStorageObj = Record<ColorType, string[]>;

const LOCAL_STORAGE_KEY = 'recentlyUsedColors';

// 两行
const MAX_PURE_COLORS = 9 * 2;
// 两行
const MAX_GRADIENT_COLORS = 4 * 2;

const defaultObj: LocalStorageObj = {
    pure: [],
    gradient: [],
};

const useRecentlyUsedColors = (type: ColorType) => {
    const [local = defaultObj, setLocal] = useLocalStorageState(LOCAL_STORAGE_KEY, {
        defaultValue: defaultObj,
    });

    const colors = local[type];

    const addColor = (color: string) =>
        setLocal((oldLocal) => {
            // 以 localStorage 为单一数据源，避免多实例（如 pure / gradient 同时调用）并发更新时互相覆盖
            let base: LocalStorageObj = defaultObj;
            try {
                const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
                if (stored) {
                    const parsed = JSON.parse(stored) as LocalStorageObj;
                    if (parsed && typeof parsed.pure === 'object' && typeof parsed.gradient === 'object') {
                        base = parsed;
                    }
                }
            } catch {
                // 忽略解析异常，使用 defaultObj
                base = oldLocal ?? defaultObj;
            }
            const newLocal = cloneDeep(base);

            if (!newLocal[type].includes(color)) {
                newLocal[type].unshift(color);
            }

            // 数量限制
            newLocal[type] = newLocal[type].slice(0, type === 'pure' ? MAX_PURE_COLORS : MAX_GRADIENT_COLORS);
            return newLocal;
        });

    return {
        colors,
        addColor,
    };
};

export default useRecentlyUsedColors;
